import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=d40dd468&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Empresas.vue?vue&type=style&index=1&id=d40dd468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40dd468",
  null
  
)

export default component.exports